import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'ionic-appauth';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { CustomAuthService } from './customauth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private auth: CustomAuthService, private navCtrl: NavController) {
  }

  /**
   * If authenticated, SignIn continues. 
   * @returns Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.auth.initComplete$.pipe(
      filter(complete => complete),
      switchMap(() => this.auth.isAuthenticated$),
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          this.auth.signIn();
        }
      }),
    );
  }
}
